const dataCyName = (name: string) =>
  name
    .toLowerCase()
    .replace(/^[^a-z0-9]/, "")
    .replace(/[^a-z0-9]/g, "-");

export default dataCyName;
